module.exports = [{"name":"PSaaS Terms","papers":[{"title":"Private Cloud Terms","id":"private-cloud-terms","icon":"https://cdn.auth0.com/website/assets/pages/legals/img/icon-acrobat-7d1807772f.svg","date":"May, 2020","actions":[{"action":"download","file":"https://cdn.auth0.com/website/legal/files/psaas/private-cloud-terms-4-1.pdf"},{"action":"open","file":"https://cdn.auth0.com/website/legal/files/psaas/private-cloud-terms-4-1.pdf"}]}]}]


//////////////////
// WEBPACK FOOTER
// ./src/pages/legals/psaas/data/psaasPapers.json
// module id = 1536
// module chunks = 0